import { computed, ref } from "vue";
import { type OnlineGameDetail } from "../model/online-game-detail";
import { CasinoGameType } from "../model/casino-game-type";
import { NgGameDefinition } from "../model/ng-game-definition";

/** ID of currently opened game */
const currentGameId = ref(0);

/** Flag if user plays for money */
const playForMoney = ref(false);
/** Flag if transparent game is being opened */
const transparentGame = ref(false);

// Revert changes from FE-4801 only for games
const netLoss = ref<number | null>(null);

const sessionStart = ref<number | null>(null);

const currentGameServerData = ref<OnlineGameDetail | null>(null);

const ngGameDefinition = ref<NgGameDefinition | null>(null);

const isLiveDealerGameOpen = computed(() => {
    return currentGameId.value !== 0 && currentGameServerData.value.type === CasinoGameType.livedealer;
});

export const useNgCasinoState = () => {
    return {
        currentGameId,
        playForMoney,
        transparentGame,
        netLoss,
        sessionStart,
        currentGameServerData,
        ngGameDefinition,
        isLiveDealerGameOpen,
    };
};
